<template>
  <section class="maison_image_text" :style="sectionStyles">
    <div class="big_container">
      <!-- sec content -->
      <div class="sec_content">
        <div class="sec_content_inner">
          <div class="sec_img">
            <div class="image_grid">
              <img
                v-lazy="shopifyData.SecImg.src"
                :placeholder="shopifyData.SecImg.placeholder"
                :alt="shopifyData.SecImg.alt || 'Maison Image Text Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Maison Image Text Image"
                width=""
                height=""
              />
            </div>
          </div>
          <div class="sec_text">
            <p class="sec_info body_text" v-html="sanitizeHtml(shopifyData.info)" />
            <h4 class="card_heading_b" v-html="sanitizeHtml(shopifyData.name)" />
            <h4 class="card_heading_b" v-html="sanitizeHtml(shopifyData.jobTitle)" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sectionStyles() {
      const deskPaddingTop = `${this.shopifyData.deskPaddingTop}px`;
      const mobPaddingTop = `${this.shopifyData.mobPaddingTop}px`;
      const deskPaddingBottom = `${this.shopifyData.deskPaddingBottom}px`;
      const mobPaddingBottom = `${this.shopifyData.mobPaddingBottom}px`;

      return {
        'padding-top': window.innerWidth > 768 ? deskPaddingTop : mobPaddingTop,
        'padding-bottom': window.innerWidth > 768 ? deskPaddingBottom : mobPaddingBottom,
      };
    },
  },
  methods: {
    sanitizeHtml,
  },
};
</script>

<style scoped>
.sec_content_inner {
  display: flex;
  align-items: center;
  gap: 107px;
}

.sec_text {
  max-width: 445px;
  width: 100%;
}

.sec_content_inner > div {
  width: 50%;
}

.body_text {
  margin-bottom: 40px;
}

.body_text:last-child {
  margin-bottom: 0;
}

.image_grid img {
  width: 100%;
}

.sec_content {
  padding: 0 50px;
}

.card_heading_b.sec_inner_heading {
  margin: 14px 0;
  text-align: start;
}

/* ===== RESPONSIVE BREAKPOINTS START ===== */
@media screen and (max-width: 1024px) {
  .sec_content_inner {
    gap: 30px;
  }

  .sec_content {
    padding: 0;
  }
}

@media screen and (max-width: 767px) {
  .sec_content_inner {
    flex-direction: column;
    gap: 10px;
  }

  .sec_content_inner > div {
    width: 100%;
  }

  .image_grid img {
    margin-left: -15px;
    margin-right: -15px;
    max-width: calc(100% + 30px);
    width: auto;
  }

  .sec_text {
    padding: 0 10px;
    max-width: 100%;
  }
}
</style>
